export default __webpack_public_path__ + "static/media/List-documentation.6d59490f.md";